import { FCCGapProductRecommendation } from "~/features/saleRecommendations/components/SchaefflerFCCGapProductsRecommendationComponent";
import type ComponentTypes from "~/features/cms/componentTypes";

/**
 * CMS wrapper for {@code SchaefflerFCCGapProductsRecommendationComponent}.
 *
 * <p>The BFF transformer
 * ({@code SchaefflerFCCGapProductsRecommendationComponentTransformer}) emits only the component
 * {@code componentId} (the uid). The actual FCC gap product recommendations are fetched client-side
 * by {@link FCCGapProductRecommendation} (the same React island the legacy
 * {@code schaefflerfccgapproductsrecommendationcomponent.jsp} mounted proplessly via
 * {@code createComponentAtId}). Any serialized config is therefore intentionally ignored here; the
 * island owns its data and rendering, mirroring the pre-shell JSP behavior.
 */
export interface CMSFccRecommendationProps {
  type: ComponentTypes.CMSFccRecommendation;
  id?: string;
  className?: string;
}

export const CMSFccRecommendation = (_props: CMSFccRecommendationProps) => {
  return <FCCGapProductRecommendation />;
};
